'use strict';

var $ = window.jQuery = require('jquery'); /* needed for Magnific Pop-up */

/* ========================================================
 * 		Requires
 ========================================================= */
// Polyfills
require('./polyfills/requestAnimationFrame.js');

// Lib
require('@plaudit/jsf-ajax-adapters/dist/jQuery');

// Components
var Forms = require('./lib/Forms.js');
var MobileMenu = require('./site/MobileMenu.js');
var Header = require('./site/Header.js');
var Global = require('./site/Global.js');
var EmploymentForm = require('./site/EmploymentForm.js');

/* ========================================================
 * 		Component Setup
 ========================================================= */
Forms.init();
MobileMenu.init();
Header.init();
Global.init();
EmploymentForm.init();
require('./site/VideoResources.js').init();
